var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSync = function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m9.706 1.708-.312.311c3.665.207 6.588 3.236 6.605 6.947L16 9a1 1 0 1 1-2 0c0-2.598-2.001-4.716-4.54-4.953l.246.246a1 1 0 1 1-1.414 1.414l-1.999-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.413 1.415M2 7c0 2.598 2.001 4.716 4.539 4.953l-.246-.246a1 1 0 1 1 1.414-1.415l1.999 2.001a1 1 0 0 1 0 1.414l-1.999 2a1 1 0 0 1-1.414-1.415l.312-.312C2.932 13.773.005 10.731 0 7.01V7a1 1 0 0 1 2 0",
    clipRule: "evenodd"
  })));
};
export default SvgSync;